import { useRouter } from 'next/router';
import React, { useMemo } from 'react';

import NextImageV2 from '../../../../ui/components/NextImageV2';
import { FooterContentEntity } from '../../domain/entities/FooterContentEntity';
import {
  PORTER_RATING,
  PORTER_RATING_ALT,
  getFooterText,
} from '../../domain/store/FooterStore';
import styles from '../styles/Footer.module.scss';

import FooterDownloadAppCmp from './FooterDownloadAppCmp';

interface FooterDownloadQrCmpProps {
  footer_data?: FooterContentEntity;
  isDesktop: boolean;
}

function FooterDownloadQrCmp({
  footer_data,
  isDesktop,
}: Readonly<FooterDownloadQrCmpProps>): React.ReactElement | null {
  const { locale } = useRouter();
  const { downloadApp, scanQr } = useMemo(
    () => getFooterText(locale),
    [locale],
  );

  if (!footer_data || footer_data.download_app_qr.path.length === 0) {
    return null;
  }

  return (
    <div className={styles['download-app-container']}>
      <div className={styles['dotted-divider']} />
      <div className={styles['footer-rating-download']}>
        <NextImageV2
          src={PORTER_RATING}
          alt={PORTER_RATING_ALT}
          height={40}
          width={40}
          quality={100}
        />
        <div>
          <div className={styles['footer-brand-heading']}>{downloadApp}</div>
          <div className={styles['footer-download-app-sub-text']}>{scanQr}</div>
        </div>
      </div>
      <div className={styles['download-app-desktop-container']}>
        <FooterDownloadAppCmp
          styles={styles}
          isDesktop={isDesktop}
          footer_data={footer_data}
        />
      </div>
    </div>
  );
}

export default FooterDownloadQrCmp;
